enum ActionType {
    REQUEST_NODES = '[CORE/NODES] GET NODES ',
    RECEIVE_NODES = '[CORE/NODES] SET NODES RECEIVE',
    RECEIVE_NODES_FOR_AGENT = '[CORE/NODES] SET NODES FOR AGENT RECEIVE',
}

export default ActionType
